/**
* 轮播图管理
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/welcome' }">基础信息管理</el-breadcrumb-item>
      <el-breadcrumb-item>轮播图片管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="search">
      <el-form-item label="类型：">
        <el-select v-model="formInline.type" placeholder="请选择类型" style="width: 100%;">
          <el-option label="全部" value=""/>
          <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value"/>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search()">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="bannerAdd()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="bannerData" highlight-current-row v-loading="loading" border
              element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="left" sortable prop="type" label="类型" :formatter="contentFormat"/>
      <el-table-column align="left" prop="url" label="图片">
        <template slot-scope="scope">
          <el-image v-if="scope.row.url != null && scope.row.url != ''" style="width: 50px; height: 50px"
                    :src="scope.row.url"
                    :preview-src-list="picturePreview(scope.row.url)"/>
        </template>
      </el-table-column>
      <el-table-column align="left" prop="link" label="链接" show-overflow-tooltip/>
      <el-table-column align="left" prop="content" label="内容" show-overflow-tooltip/>
      <el-table-column align="center" prop="sort" label="排列序号" width="100"/>
      <el-table-column align="center" label="操作" width="160">
        <template slot-scope="scope">
          <el-button size="mini" @click="bannerEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="bannerDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <!--<Pagination v-bind:child-msg="pageParam" @callFather="callFather"></Pagination>-->
    <!-- 新增编辑界面 -->
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="editFormVisible" width="50%"
               @close='closeDialog("edit")'>
      <el-form label-width="95px" ref="editForm" :model="editForm" :rules="rules">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="grid-content bg-purple">
              <el-form-item label="类型" prop="type">
                <el-select v-model="editForm.type" placeholder="请选择" style="width: 90%;">
                  <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value"/>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="grid-content bg-purple">
              <el-form-item label="排列序号" prop="sort">
                <el-input-number v-model="editForm.sort" :min="1" :max="100" :step="1" label="排列序号" step-strictly
                                 style="width: 100%;"/>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-form-item label="跳转链接" prop="link">
                <el-input size="small" v-model="editForm.link" placeholder="请输入跳转链接"/>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="grid-content bg-purple" style="height: 300px;">
              <el-form-item label="内容" prop="content">
                <quill-editor
                  class="editor"
                  v-model="editForm.content"
                  ref="myQuillEditor"
                  :options="editorOption"
                  @blur="onEditorBlur($event)"
                  @focus="onEditorFocus($event)"
                  @change="onEditorChange('content')">
                </quill-editor>
                <el-upload
                  class="quill-upload-demo"
                  action="/api/oss/upload"
                  accept="image/jpeg,image/jpg,image/png"
                  :http-request="quillUploadFile"
                  :before-upload="beforeAvatarUpload"
                  :on-success="handleSuccess"
                  :show-file-list="false"
                />
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-form-item>
                <el-upload
                  class="upload-demo"
                  action="/api/oss/upload"
                  accept="image/jpeg,image/jpg,image/png"
                  :on-remove="removeFile"
                  :http-request="uploadFile"
                  :file-list="fileList"
                  :class="fileList.length===1?'hide_box':''"
                  list-type="picture-card">
                  <el-button size="small" type="primary">上传图片</el-button>
                  <div slot="tip" class="el-upload__tip">只能上传jpeg/jpg/png文件</div>
                </el-upload>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 导入请求方法
import {bannerList, bannerSave, bannerUpdate, bannerDelete} from '../../api/bannerMG'
import Pagination from '../../components/Pagination'

// 工具栏配置
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
  ["blockquote", "code-block"], // 引用  代码块
  [{header: 1}, {header: 2}], // 1、2 级标题
  [{list: "ordered"}, {list: "bullet"}], // 有序、无序列表
  [{script: "sub"}, {script: "super"}], // 上标/下标
  [{indent: "-1"}, {indent: "+1"}], // 缩进
  // [{'direction': 'rtl'}],                         // 文本方向
  [{size: ["small", false, "large", "huge"]}], // 字体大小
  [{header: [1, 2, 3, 4, 5, 6, false]}], // 标题
  [{color: []}, {background: []}], // 字体颜色、字体背景颜色
  [{font: []}], // 字体种类
  [{align: []}], // 对齐方式
  ["clean"], // 清除文本格式
  ["image"] // 链接、图片、视频
];

export default {
  data() {
    // 请求数据参数
    return {
      loading: false, //是显示加载
      title: '添加酒店信息',
      editFormVisible: false, //控制编辑页面显示与隐藏
      typeList: [{value: "HOME_PAGE", label: "首页轮播图"}, {value: "ADVERTISEMENT", label: "表白墙广告"}],
      // 编辑与添加
      editForm: {id: '', type: '', url: '', link: '', content: '', sort: ''},
      formInline: {type: '', pageNum: 1, pageSize: 20},
      // 分页参数
      pageParam: {currentPage: 1, pageSize: 20, total: 20},
      //列表数据
      bannerData: [],
      rules: {
        type: [{required: true, message: '请选择类型', trigger: 'blur'}],
        sort: [{required: true, message: '请输入排列序号', trigger: 'blur'}]
      },
      fileList: [], //文件集合
      editorOption: {
        placeholder: "请输入内容",
        theme: "snow",
        modules: {
          // imageResize: {}, //图片拖动设置大小
          // imageDrop: true, // 图片拖动
          toolbar: {
            container: toolbarOptions,
            handlers: {
              image: (value) => {
                if (value) {
                  // 这是是为了获取你当前点击的那个富文本框
                  document.querySelectorAll('.quill-upload-demo input')[0].click()
                } else {
                  this.quill.format('image', false)
                }
              }
            }
          }
        }
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  computed: {},
  /**
   * 数据发生改变
   */
  watch: {
  },
  /**
   * 创建完毕,初始化数据
   */
  created() {
    this.getdata(this.formInline)
  },
  methods: {
    //获取列表
    getdata(parameter) {
      bannerList(parameter).then(res => {
        this.loading = false
        if (res.code != 0) {
          this.$message({type: 'warning', message: res.msg})
        } else {
          this.bannerData = res.data
          // 分页赋值
          // this.pageParam.currentPage = res.result.pagination.current
          // this.pageParam.pageSize = res.result.pagination.pageSize
          // this.pageParam.total = res.result.pagination.total
        }
      })
    },
    //搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //轮播图新增、编辑弹窗
    bannerAdd: function (index, row) {
      this.editFormVisible = true;
      this.title = '添加轮播图片信息';
      this.editForm.id = '';
      this.editForm.type = '';
      this.editForm.url = '';
      this.editForm.link = '';
      this.editForm.content = '';
      this.editForm.sort = '';
    },
    bannerEdit: function (index, row) {
      this.editFormVisible = true;
      this.title = '修改轮播图片信息';
      this.editForm.id = row.id;
      this.editForm.type = row.type;
      this.editForm.url = row.url;
      this.editForm.link = row.link;
      this.editForm.sort = row.sort;
      this.editForm.content = row.content;
      //图片预览
      if (row.url != null && row.url != '') {
        this.fileList.push({'url': row.url});
      }
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.pageNum = parm.currentPage
      this.formInline.pageSize = parm.pageSize
      this.getdata(this.formInline)
    },
    //文件上传方法
    uploadFile(param) {
      console.log(param)
      var data = new FormData();
      data.append("file", param.file);
      var config = {headers: {'Content-Type': 'multipart/form-data', token: localStorage.getItem('logintoken')}}
      this.$axios.post(param.action, data, config).then((res) => {
        if (res.data.code == 0) {
          let url = res.data.data;
          this.editForm.url = url;
          this.fileList.push({'url': url});
        } else {
          this.$message({type: 'warning', message: res.data.msg})
        }
      })
    },
    //文件删除方法
    removeFile(file) {
      this.editForm.url = '';
      this.fileList = [];
    },
    //富文本图片上传方法
    quillUploadFile(params) {
      const formData = new FormData()
      formData.append('file', params.file)
      var config = {headers: {'Content-Type': 'multipart/form-data', token: localStorage.getItem('logintoken')}}
      this.$axios.post(params.action, formData, config).then((res) => {
        this.handleSuccess(res.data)
      })
    },
    //富文本判断图片后缀
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || 'image/png' || 'image/jpg'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG) {
        this.$message.error('图片上传只支持jpeg、jpg、png格式！')
      }
      if (!isLt2M) {
        this.$message.error('图片上传大小不能超过2MB！')
      }
      return isJPG && isLt2M;
    },
    //富文本图片上传成功
    handleSuccess(res) {
      console.log("图片上传成功")
      console.log(res)
      if (res.code == 0) {
        // 动态添加 ref  通过 eval () 去执行
        const toeval = this.$refs.myQuillEditor.quill
        // eval() 函数可计算某个字符串，并执行其中的的 JavaScript 代码。
        // 获取光标所在位置
        const length = toeval.selection.savedRange.index
        // 插入图片，res为服务器返回的图片链接地址
        toeval.insertEmbed(length, 'image', res.data)
        // 调整光标到最后
        toeval.setSelection(length + 1)
      }
    },
    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.editFormVisible = false
      }
      this.fileList = []
    },
    //新增、编辑界面保存
    submitForm(editData) {
      if (this.editForm.url == null || this.editForm.url == '') {
        this.$message({type: 'warning', message: '请上传图片'})
        return
      }
      this.$refs[editData].validate(valid => {
        if (valid) {
          if (this.editForm.id == undefined || this.editForm.id.length <= 0) {
            bannerSave(this.editForm).then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code == 0) {
                this.getdata(this.formInline)
                this.$message({type: 'success', message: '保存成功！'})
                this.$refs['editForm'].resetFields();
              } else {
                this.$message({type: 'warning', message: res.msg})
              }
            }).catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
          } else {
            bannerUpdate(this.editForm).then(res => {
              this.editFormVisible = false
              //this.loading = false
              if (res.code == 0) {
                this.getdata(this.formInline)
                this.$message({type: 'success', message: '更新成功！'})
              } else {
                this.$message({type: 'warning', message: res.msg})
              }
            })
          }
        } else {
          return false
        }
      })
    },
    // 删除酒店信息
    bannerDelete(index, row) {
      this.$confirm('此操作无法撤销，确定删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        bannerDelete({id: row.id}).then(res => {
          if (res.code == 0) {
            this.$message({type: 'success', message: '数据已删除!'})
            this.getdata(this.formInline)
          } else {
            this.$message({type: 'warning', message: res.message})
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('数据删除失败，请稍后再试！')
        })
      }).catch(() => {
        this.$message({type: 'error', message: '删除异常！'})
      })
    },
    //类型格式化
    contentFormat(row, column, callValue) {
      let name = "-";
      switch (row.type) {
        case "HOME_PAGE":
          name = "首页轮播图"
          break;
        case "ADVERTISEMENT":
          name = "表白墙广告"
          break;
      }
      return name;
    },
    //富文本框相关事件
    onEditorBlur() {
      //失去焦点事件
    },
    onEditorFocus() {
      //获得焦点事件
    },
    onEditorChange(val) {
    },
    //图片预览大图
    picturePreview(pictureUrl) {
      let list = [pictureUrl];
      return list;
    },
  }
}
</script>

<style scoped>
.search {
  margin-top: 20px;
}

/**
 * 隐藏样式  >>> 根据需要添加(如果用的脚手架样式不能覆盖)
 */
.hide_box >>> .el-upload--picture-card {
  display: none;
}

/**
 * 富文本框样式
 */
.editor {
  line-height: normal !important;
  height: 200px;
}

.ql-snow .ql-tooltip[data-mode=link]::before {
  content: "请输入链接地址:";
}

.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
  border-right: 0px;
  content: '保存';
  padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode=video]::before {
  content: "请输入视频地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: '14px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
  content: '10px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
  content: '18px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
  content: '32px';
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: '文本';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: '标题1';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: '标题2';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: '标题3';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: '标题4';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: '标题5';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: '标题6';
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: '标准字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
  content: '衬线字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
  content: '等宽字体';
}
</style>



// WEBPACK FOOTER //
// src/views/banner/banner.vue